import Typography from "components/common/Typography/Typography";
import {
  ERROR,
  SUCCESS,
  TABLE_API_CONNECTED,
  TABLE_HEADING,
  TABLE_SUBTITLE,
} from "config/profile_constants";
import React from "react";
import DUMMY_TABLE_DATA from "config/dummy_table_data.json";
import {
  ProfileGraphSectionWrapper,
  Subtitle,
} from "../ProfileGraph/ProfileGraph";
import Table from "components/common/Table/Table";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import Flex from "components/common/Layout/Flex/Flex";
import Section from "../Layouts/Section";

const GainsCell = ({ value, increased }) => {
  return (
    <>
      <Flex justifyContent={"center"} direction="row" spacing={"0.4rem"}>
        {increased ? value : <>({value})</>}

        {increased ? (
          <AiOutlineArrowUp color={SUCCESS} />
        ) : (
          <AiOutlineArrowDown color={ERROR} />
        )}
      </Flex>
    </>
  );
};

const ProfileTable = () => {
  const [tableData, setTableData] = React.useState([]);

  React.useEffect(() => {
    if (TABLE_API_CONNECTED) {
      // API ENDPOINT CONNECTION HERE
    } else {
      setTableData(DUMMY_TABLE_DATA);
    }
  }, []);

  const SAMPLE_DATASET = {
    project_name: "Kare",
    term:"two years",
    initial_investment: "$61.32",
    return_1_2_3_years: "32%",
    current_balance:"$500.52",
    current_balance: "$41.42",
  };

  const generateHeadings = () => {
    const HEADINGS = Object.keys(SAMPLE_DATASET).map((eachKey) => {
      const buildLabel = eachKey
        .split("_")
        .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
        .join(" ");
      return { Header: buildLabel, accessor: eachKey };
    });
    let current_balance = HEADINGS.find((heading) => heading.accessor === "current_balance");
    const current_balance_INDEX = HEADINGS.findIndex(
      (heading) => heading.accessor === "current_balance"
    );
    current_balance = {
      ...current_balance,
      Cell: (params) => {
        const current_balance = params?.row?.original?.current_balance;
        const isProfit = params?.row?.original?.is_profit;
        return <GainsCell increased={isProfit} value={current_balance} />;
      },
    };

    HEADINGS.splice(current_balance_INDEX, 1, current_balance);
    return HEADINGS;
  };
  /**"id":1,"project_name":"Kare","project_location":"5557 Morrow Parkway","initial_investment":"$61.32","return_percentage":"32%","gains":"$41.42","category":"Paid" */

  return (
    <Section>
      <div>
        <Table data={tableData} cols={generateHeadings()} />
      </div>
    </Section>
  );
};

export default ProfileTable;
